var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"TMGeneralButton",class:_vm.className,attrs:{"event":!_vm.disabled ? 'click' : '',"to":{ name: _vm.route, params: _vm.routeParams }}},[_c('b',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }